import Vue from "vue";

export const log = {
  info: (...args: any[]) => Vue.$log.info(...args),
  debug: (...args: any[]) => Vue.$log.debug(...args),
  warn: (...args: any[]) => Vue.$log.warn(...args),
  error: (...args: any[]) => Vue.$log.error(...args)
};
